import { useQuery } from "@apollo/client/react"; import { useState, useMemo, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneIcon from '@mui/icons-material/Done';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { GET_PANTALLAS_RI } from '../../../data/graphQL/queries/ResumenIngreso/getPantallasRI';
import { adaptPantallasRIArray } from '../../../adapters/resumenIngreso/pantallasRIAdapter';
import { getEditNavigationState, getEditRouteByTab } from '../helpers/navigationHelper';
import {
  columnsIndicaciones,
  columnsIndicacionesWithoutFechaRealizacion,
  columnsIndicacionesWithoutUsuarioRealizador,
  columnsPrograma,
  columnsProgramasWithoutFechaRealizacion,
  columnsEquipo,
  columnsEquipoWithoutFechaRealizacion
} from
  '../constants/columns';
import { columnsAsignacion, columnsAsignacionWithRIData } from '../constants/columnsAsignacion';
import { columnsResumenIngreso, columnsRIWithFechaRealizacion, columnsRIWithColumnDemora } from '../constants/columnsRI';

export const useGetColumns = ({
  tabs,
  tipoModuloEnum,
  tipoModuloConIndicacion,
  estado,
  estadosOptions,
  activeTabEnum,
  estadoValidado
}) => {
  const navigate = useNavigate();
  const [pantallas, setPantallas] = useState([]);

  const estadosSeleccionados = useMemo(() => {
    if (!estadosOptions) return {};

    return {
      sinAsignacion: estadosOptions.find((x) => x.displayName === 'Sin Asignación')?.id,
      asignado: estadosOptions.find((x) => x.displayName === 'Asignado')?.id,
      realizado: estadosOptions?.find((x) => x.displayName == 'Realizado')?.id,
      rechazado: estadosOptions?.find((x) => x.displayName == 'Rechazado')?.id,
      demorado: estadosOptions?.find((x) => x.displayName == 'Demorado')?.id,
      pendiente: estadosOptions?.find((x) => x.displayName == 'Pendiente')?.id,
      correccion: estadosOptions?.find((x) => x.displayName == 'Correccion')?.id
    };
  }, [estadosOptions]);

  const getTextAction = useMemo(() => {
    if (activeTabEnum === 'ASIGNACION') {
      if (estado === estadosSeleccionados?.sinAsignacion || estado === estadosSeleccionados?.asignado)
        return 'Asignar'; else

        return 'Ver';
    }

    if (estado === estadosSeleccionados?.realizado || estado === estadosSeleccionados?.rechazado)
      return 'Ver';

    return 'Validar';
  }, [activeTabEnum, estadoValidado, estado]);

  const { loading: getPantallasLoading, data: dataPantallasRI } = useQuery(GET_PANTALLAS_RI, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!dataPantallasRI) return;

    const pantallasRI = adaptPantallasRIArray(dataPantallasRI);
    setPantallas(pantallasRI);
  }, [dataPantallasRI]);

  const handleClickEdit = (row) => {
    const { auxDataState, flags } = getEditNavigationState({
      row,
      tabs,
      pantallas,
      tipoModuloEnum,
      tipoModuloConIndicacion
    });

    const route = getEditRouteByTab(activeTabEnum);

    if (!!route)
      navigate(route, { state: { ...auxDataState, ...flags } });
  };

  const actionColumn = {
    headerName: '',
    field: 'action',
    flex: 0.0005,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return <>
        <PopoverModal>
          <div className='popover-modal-content'>
            <div onClick={() => handleClickEdit(row)} aria-hidden='true'
              className='item-option clickable-option'>

              {getTextAction === 'Ver' && <VisibilityIcon className='edit-icon' />}
              {getTextAction === 'Asignar' && <EditIcon className='edit-icon' />}
              {getTextAction === 'Validar' && <DoneIcon className='edit-icon' />}
              <span className='toggle-action'>{getTextAction}</span>
            </div>
          </div>
        </PopoverModal>
      </>;
    }
  };

  const getColumnsByTab = (activeTabEnum, estado) => {
    if (activeTabEnum === 'ASIGNACION') {
      if (estado === estadosSeleccionados?.asignado)
        return columnsAsignacionWithRIData;
      return columnsAsignacion;
    }

    if (activeTabEnum === 'VALIDACION') {
      if (estado === estadosSeleccionados?.demorado)
        return columnsRIWithColumnDemora;

      if (estado === estadosSeleccionados?.pendiente || estado === estadosSeleccionados?.correccion)
        return columnsResumenIngreso;

      return columnsRIWithFechaRealizacion;
    }

    if (activeTabEnum.includes('INDICACION')) {
      if (estado === estadosSeleccionados?.pendiente)
        return columnsIndicacionesWithoutUsuarioRealizador; else
        if (estado === estadosSeleccionados?.correccion)
          return columnsIndicacionesWithoutFechaRealizacion; else

          return columnsIndicaciones;
    }

    if (activeTabEnum.includes('PROGRAMA')) {
      if (estado === estadosSeleccionados?.pendiente)
        return columnsProgramasWithoutFechaRealizacion; else

        return columnsPrograma;
    }

    if (activeTabEnum === 'CONFIRMAR_EQUIPO') {
      if (estado === estadosSeleccionados?.pendiente || estado === estadosSeleccionados?.correccion)
        return columnsEquipoWithoutFechaRealizacion; else

        return columnsEquipo;
    }
  };

  const initialColumns = useMemo(() => {
    const baseColumns = getColumnsByTab(activeTabEnum, estado);
    return [actionColumn, ...baseColumns];
  }, [activeTabEnum, pantallas, estado]);

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [tabs, estado, activeTabEnum]);

  return columns;
};